import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmail, sendVerificationEmail, changeContactDetails } from "../../api_endpoints/UserLoginSignupAPI";
import { getUserLogout, getUserSuccess, removeGlobalState } from "../../redux/user/userActions";
import { showLoader, showToast } from "../../redux/common/commonActions";
import palette from "../../theme/palette"
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import VerifiedIcon from "@mui/icons-material/Verified";
import Backdrop from "@mui/material/Backdrop";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import Error from "../../components/error-msg"
import InputLabel from "@mui/material/InputLabel";
import { submitScam } from "src/redux/scam/scamActions";

const loadBtnSX = {
  ".MuiLoadingButton-loadingIndicator": { color: palette.primary.main },
};

const sx = {
  width: "50px",
  fontSize: "1rem",
  textAlign: "center",
  alignItems: "center",
  "& .MuiInputBase-input.MuiOutlinedInput-input": { textAlign: "center" },
};

export default function EmailVerification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.userState.isLoggedIn);
  const userState = useSelector((state) => state.userState);
  const { preScamData } = useSelector((state) => state.scamState);
  const [success, setSuccess] = useState(0);
  const [isLoading, setIsLoading] = useState(true)
  const [color, setColor] = useState("red");
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('')
  const [isSendingShowCount, setIsSendingShowCount] = useState(0)
  const [showHomeBtn, setShowHomeBtn] = useState(false)
  const [showSendEmailBtn, setShowSendEmailBtn] = useState(false)

  const [timer, setTimer] = useState(60); // 1 minutes in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [screen, setScreen] = useState(1)

  const regex = /^[0-9]\d{0,1}$/;
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const [open, setOpen] = useState(true);
  const [otp, setOtp] = useState(true);
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [num3, setNum3] = useState("");
  const [num4, setNum4] = useState("");
  const [otpVerified, setOtpVerified] = useState("");
  const [showExitButton, setShowExitButton] = useState(false)
  const [exitType, setExitType] = useState(undefined)

  const loaderStatus = false;

  const [revisedEmail, setRevisedEmail] = useState({
    email: "",
    emailError: false
  })

  const handleNext = () => {
    window.location.reload();
  }

  const goBack = () => {
    dispatch(removeGlobalState())
  }

  useEffect(() => {
    if (window?.location?.pathname !== "/thank-you" && !isLoggedIn) {
      setIsLoading(false)
      handleUrlChanges("/login")
      dispatch(showLoader({ show: false, msg: "" }));
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!success) {
        // e.preventDefault();
        localStorage.clear();
        dispatch(getUserLogout());
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [success]);

  useEffect(() => {
    let interval;
    if (isTimerRunning) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 0) {
            clearInterval(interval);
            setIsTimerRunning(false);
            return 60;
          } else {
            return prevTimer - 1;
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isTimerRunning]);

  useEffect(() => {
    if (num1 !== "" && num2 !== "" && num3 !== "" && num4 !== "") {
      setOtp(num1 + num2 + num3 + num4);
    }
  }, [num1, num2, num3, num4]);

  useEffect(() => {
    if (isLoading && isSendingShowCount < 3) {
      dispatch(showLoader({ show: true, msg: "Email verification in progress ..." }));
      setIsSendingShowCount(isSendingShowCount + 1);
      setTimeout(() => {
        dispatch(showLoader({ show: false, msg: "" }));
      }, 5000)
    } else {
      dispatch(showLoader({ show: false, msg: "" }));
    }
  }, [isLoading, isSendingShowCount])

  const submitEmailVerification = () => {
    const userEmail = userState?.userData?.email ?? ""
    if (userEmail !== '') {
      dispatch(showLoader({ show: true, msg: "Email verification in progress..." }));
      var param = {
        email: userEmail,
        otp: otp,
      };
      const response = verifyEmail(param);
      Promise.resolve(response).then(
        (res) => {
          if (res?.error) {
            setExitType('back')
            dispatch(showToast({ show: true, msg: res?.message ?? "Something went wrong, kindly try again..." }));
            setTimeout(() => {
              dispatch(showLoader({ show: false, msg: "" }));
            }, 4500)
            setSuccess(false);
          } else if (res?.code === 200) {
            // handleUrlChanges("/thank-you")
            // setSuccess(true);

            setExitType('next')
            setTimeout(() => {
              if (isLoggedIn) {
                var userInfo = userState;
                userInfo.userData.email_verified = 2;
                userInfo.email_verified = 2;

                dispatch(getUserSuccess(userInfo));
                setSuccess(true);
                dispatch(showToast({ show: true, msg: (res?.message ?? "") + " Please wait while we auto redirect you..." }));
                //scam pre start
                if (preScamData) {
                  const formData = new FormData();
                  formData.append("comment", preScamData.comment);
                  formData.append("user_id", userInfo.userID);

                  if (preScamData.files && preScamData.files.length > 0) {
                    preScamData.files.forEach((file, index) => {
                      // Append the binary content of the file
                      if (file.file instanceof Blob) {
                        formData.append(`file_${index}`, file.file);
                      } else {
                        console.error(`Invalid file at index ${index}`);
                      }
                    });
                  }
                  dispatch(submitScam(formData));
                }
                //pre scam end
                setTimeout(() => {
                  dispatch(showLoader({ show: false, msg: "" }));
                }, 4500)
                // Check if preScamData exists and submit the scam data if needed
                
              } else {
                dispatch(showToast({ show: true, msg: (res.message ?? "") + "Please login to continue..." }));
                setTimeout(() => {
                  dispatch(showLoader({ show: false, msg: "" }));
                }, 4500)
                setSuccess(true);
                handleUrlChanges("/thank-you", false)
              }
            }, 1500);
          } else {
            setExitType('next')
            setTimeout(() => {
              dispatch(showLoader({ show: false, msg: "" }));
            }, 4500)
            dispatch(showToast({ show: true, msg: res.message }));
            setSuccess(false);
          }
        },
        (reason) => {
          setExitType(undefined)
          dispatch(showLoader({ show: false, msg: "" }));
          setSuccess(false);
        }
      );
    } else {
      setExitType('back')
      dispatch(showToast({ show: true, msg: 'Something went wrong, please try again!' }));
      setTimeout(() => {
        dispatch(showToast({ show: false, msg: '' }));
        handleUrlChanges('/login')
      }, 100)

    }
  };

  const sendEmailToUser = (newEmail) => {
    const userEmail = userState?.userData?.email ?? ""
    if (userEmail !== '') {
      if (!isTimerRunning || newEmail) {
        setIsTimerRunning(true);
        var param = {
          email: newEmail ?? userEmail,
        };
        const response = sendVerificationEmail(param);
        Promise.resolve(response).then(
          (res) => {
            if (!res.error) {
              if (res?.email_verified) {
                // setOtpVerified(true);
                setExitType('next')
                handleUrlChanges("/thank-you", false)
                setSuccess(true);
                dispatch(showToast({ show: true, msg: 'You are now verified with us!' }));
                // setTimeout(() => {
                //   var userInfo = userState;
                //   userInfo.userData.email_verified = 2;
                //   userInfo.email_verified = 2;
                //   navigate("/thank-you");
                //   setSuccess(true);
                // }, 1500);
              } else {
                setExitType('back')
                setOtpVerified(false);
                dispatch(showToast({ show: true, msg: 'Email sent for verification!' }));
                setTimeout(() => {
                  dispatch(showToast({ show: false, msg: '' }));
                }, 4500)
              }
            } else {
              setExitType('back')
              setOtpVerified(false);
              dispatch(showToast({ show: true, msg: res?.message || 'Something went wrong, kindly try again...' }));
            }
          },
          (reason) => {
            setExitType('next')
            dispatch(showLoader({ show: false, msg: "" }));
            setSuccess(false);
          }
        );
      }
    } else {
      setExitType('back')
      handleUrlChanges('/login')
    }
  }

  // useEffect(() => {
  //   if (searchParams.get("e") !== null) {
  //     submitEmailVerification(searchParams.get("e"));
  //   } else {
  //     setShowSendEmailBtn(true)
  //   }
  // }, [searchParams]);

  const handleUrlChanges = (url, clearState = true) => {
    navigate(url)
    if (clearState) {
      dispatch(getUserLogout());
      setTimeout(() => {
        localStorage.clear();
      }, 1000)
    }
  }

  const handleValChange = (event) => {
    let { value, name } = event.target;

    if (value && value?.trim()?.length > 0) {
      setRevisedEmail({
        ...revisedEmail,
        email: value,
        emailError: false
      })
    } else {
      setRevisedEmail({
        ...revisedEmail,
        email: "",
        emailError: true
      })
    }
  }

  const handleEmailChange = () => {
    const checkFields = !revisedEmail?.email || !revisedEmail?.email?.trim()?.length ||
      revisedEmail?.emailError

    if (checkFields) {
      dispatch(showToast({ show: true, msg: "Please fill all fields" }));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex?.test(revisedEmail?.email)) {
      setRevisedEmail({
        ...revisedEmail,
        email: "",
        emailError: true
      })
    }

    if (!userState?.userID || !userState?.userData?.email || !userState?.userData?.phone) {
      dispatch(showToast({ show: true, msg: "Something went wrong, please try again..." }));
      return;
    }

    dispatch(showLoader({ show: true, msg: "Updating email address" }));
    const param = {
      user_id: userState?.userID,
      currEmail: userState?.userData?.email,
      currPhone: userState?.userData?.phone,
      newEmail: revisedEmail?.email ?? "",
      updateType: 'email'
    };
    const response = changeContactDetails(param);
    Promise.resolve(response).then(
      (res) => {
        if (res.error) {
          const errorMsg = res?.errTypeData?.response?.data?.message ?? 'Something went wrong...'
          dispatch(showToast({ show: true, msg: errorMsg }));
        } else {
          dispatch(showToast({ show: true, msg: res.message ?? "Your email is updated successfully" }));
          let userInfo = userState;
          userInfo.userData.email = revisedEmail?.email;
          dispatch(getUserSuccess(userInfo));
          setTimer(60)
          setTimeout(() => {
            sendEmailToUser(revisedEmail?.email)
            setScreen(1)
          }, 0)
        }
        dispatch(showLoader({ show: false, msg: "" }));
      },
      (error) => {
        dispatch(showLoader({ show: false, msg: "" }));
        dispatch(showToast({ show: false, msg: "Something went wrong, kindly try again later..." }));
      }
    );
    dispatch(showLoader({ show: false, msg: "" }));
  }

  useEffect(() => {
    if (exitType && exitType === 'next') {
      setTimeout(() => {
        handleNext()
      }, 15 * 1000)
    }
  }, [exitType])

  useEffect(() => {
    ref1.current?.focus();
    sendEmailToUser()
    setTimeout(() => {
      setShowHomeBtn(true)
    }, 10 * 1000)
    setTimeout(() => {
      setShowExitButton(true)
    }, 1 * 60 * 1000)
  }, []);

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "#fff",
      }}
      open={open}
    >
      <Box
        sx={{
          width: {
            xs: "100%",
            sm: "100%",
            md: "40%",
            lg: "40%",
            xl: "40%",
          },
          maxWidth: "600px",
          backgroundColor: "#fff",
          borderRadius: "7px",
        }}
      >
        {screen === 1 ? <>
          <Box
            sx={{
              mb: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={"/logo.webp"} alt="Logo" height={40} width="auto" onClick={() => navigate('/login')} />
          </Box>
          {otpVerified ? (
            <>
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  columnGap: ".5rem",
                }}
              >
                {
                  "Your email has been successfully verified. You will be redirected to your dashboard"
                }{" "}
                <VerifiedIcon sx={{ color: "green", fontSize: "1.5rem" }} />
              </DialogTitle>
              <DialogContent>
                {(showExitButton || (exitType && exitType === 'next')) ? <>
                  <Button
                    variant="contained"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "0.75rem",
                    }}
                    onClick={() => handleNext()}
                  >
                    Next
                  </Button>
                </> : null}
              </DialogContent>
            </>
          ) : (
            <>
              <DialogTitle sx={{ textAlign: "center" }}>
                {"Enter the OTP sent on email for verification"}
              </DialogTitle>
              <DialogContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    columnGap: 2,
                    mt: 1,
                    mb: 1.5,
                  }}
                >
                  <FormControl>
                    <OutlinedInput
                      value={num1}
                      id={"num_1"}
                      type={"text"}
                      onChange={(e) => {
                        if (
                          regex.test(e.target.value) &&
                          e.target.value.length <= 1
                        ) {
                          setNum1(e.target.value);
                          ref2.current.focus();
                        } else {
                          if (e.target.value.length === 0) {
                            setNum1("");
                          }
                        }
                      }}
                      disabled={loaderStatus}
                      sx={sx}
                      inputRef={ref1}
                    />
                  </FormControl>
                  <FormControl>
                    <OutlinedInput
                      value={num2}
                      id={"num_2"}
                      type={"text"}
                      onChange={(e) => {
                        if (
                          regex.test(e.target.value) &&
                          e.target.value.length <= 1
                        ) {
                          setNum2(e.target.value);
                          ref3.current.focus();
                        } else {
                          if (e.target.value.length === 0) {
                            setNum2("");
                          }
                        }
                      }}
                      disabled={loaderStatus}
                      sx={sx}
                      inputRef={ref2}
                    />
                  </FormControl>
                  <FormControl>
                    <OutlinedInput
                      value={num3}
                      id={"num_3"}
                      type={"text"}
                      onChange={(e) => {
                        if (
                          regex.test(e.target.value) &&
                          e.target.value.length <= 1
                        ) {
                          setNum3(e.target.value);
                          ref4.current.focus();
                        } else {
                          if (e.target.value.length === 0) {
                            setNum3("");
                          }
                        }
                      }}
                      disabled={loaderStatus}
                      sx={sx}
                      inputRef={ref3}
                    />
                  </FormControl>

                  <FormControl>
                    {" "}
                    <OutlinedInput
                      value={num4}
                      id={"num_4"}
                      type={"text"}
                      onChange={(e) => {
                        if (
                          regex.test(e.target.value) &&
                          e.target.value.length <= 1
                        ) {
                          setNum4(e.target.value);
                        } else {
                          if (e.target.value.length === 0) {
                            setNum4("");
                          }
                        }
                      }}
                      disabled={loaderStatus}
                      sx={sx}
                      inputRef={ref4}
                    />
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 1, justifyContent: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    rowGap: "1rem",
                  }}
                >
                  <LoadingButton
                    loading={loaderStatus}
                    variant="contained"
                    onClick={submitEmailVerification}
                    sx={loadBtnSX}
                  >
                    Submit
                  </LoadingButton>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      // columnGap: ".50rem",
                    }}
                  >
                    <Button
                      variant="text"
                      sx={{
                        color: "#6d4cb1",
                        fontSize: "0.75rem",
                      }}
                      onClick={sendEmailToUser}
                      disabled={isTimerRunning}
                    >
                      resend OTP
                    </Button>
                    <Typography
                      variant="body"
                      sx={{
                        color: "#6d4cb1",
                        fontSize: "0.75rem",
                      }}
                    >
                      {" "}
                      {Math.floor(timer / 60)
                        .toString()
                        .padStart(2, "0")}{" "}
                      Minutes {(timer % 60).toString().padStart(2, "0")} Seconds
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      flexWrap: 'wrap'
                    }}
                  >
                    <Typography
                      variant="body"
                      sx={{
                        color: "#919EAB",
                        fontSize: "0.75rem",
                        minWidth: 'max-content'
                      }}
                    >Incorrect Email ?
                    </Typography>
                    <Button
                      variant="text"
                      sx={{
                        color: "#6d4cb1",
                        fontSize: "0.75rem",
                        minWidth: 'max-content'
                      }}
                      onClick={() => { setScreen(2) }}
                    >
                      Change Email Address
                    </Button>

                  </Box>
                  {(showExitButton || (exitType && exitType === 'back')) ? <>
                    <Button
                      variant="contained"
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "0.75rem",
                      }}
                      onClick={() => goBack()}
                    >
                      Go Back
                    </Button>
                  </> : null}
                </Box>
              </DialogActions>
            </>
          )}</> : <>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={"/logo.webp"} alt="Logo" height={40} width="auto" onClick={() => navigate('/login')} />
          </Box>
          <Box sx={{ color: '#2B2B2B' }}>
            <DialogTitle sx={{ textAlign: "center" }}>
              {`Enter your correct email address`}
            </DialogTitle>
            <DialogContent>
              <Box sx={{
                display: "flex",
                flexDirection: 'column',
                rowGap: 3,
                mb: 3,
                pt: 3
              }}>
                <Box sx={{ width: '100%' }}>
                  <FormControl fullWidth >
                    <InputLabel htmlFor="phone">New Email</InputLabel>
                    <OutlinedInput
                      id="email"
                      label="New Email"
                      value={revisedEmail.email}
                      name="email"
                      onChange={handleValChange}
                      type={"text"}
                      error={revisedEmail?.emailError === 0 ? false : revisedEmail?.emailError}
                    />
                    {revisedEmail?.emailError && revisedEmail?.emailError !== 0 &&
                      <Error errorMsg={"please fill the email"} />
                    }
                  </FormControl>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 1, justifyContent: "center" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <LoadingButton
                  loading={loaderStatus}
                  variant="contained"
                  onClick={handleEmailChange}
                  sx={loadBtnSX}
                >
                  Submit
                </LoadingButton>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: '1rem'
                  }}
                >
                  <Button
                    variant="text"
                    sx={{
                      color: "#6d4cb1",
                      fontSize: "0.75rem",
                    }}
                    onClick={() => setScreen(1)}
                  >
                    Go back to verify OTP
                  </Button>
                </Box>
              </Box>
            </DialogActions>
          </Box>
        </>}

        {exitType ? <Box sx={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Button
            variant="contained"
            sx={{
              color: "#FFFFFF",
              fontSize: "0.75rem",
            }}
            onClick={() => handleNext()}
          >
            Refresh
          </Button>
        </Box> : null}
      </Box>
    </Backdrop>
  );
}
